// utils/dom.ts — Helpers DOM purs (escape HTML, sélecteurs typés à venir).
//
// Premier fichier .ts strict du frontend (S1 du plan migration TS+Vite).
// Aucune dépendance externe — testable 100 % isolément via Vitest.
//
// État S1 (2026-05-10) : `esc` est DUPLIQUÉ dans core.js qui reste source
// of truth runtime jusqu'à la bascule FastAPI vers dist/ en S6.

/**
 * Échappe les 5 caractères qui peuvent casser une interpolation HTML
 * dans du contenu OU un attribut.
 *
 * L'apostrophe est essentielle pour les attributs single-quoted
 * (ex. `data-x='${esc(json)}'`) où un `'` dans la donnée fermerait
 * l'attribut prématurément. Audit P0 #2 (mai 2026) — ajout du `'`
 * après inspection : pas d'XSS exploité aujourd'hui, mais durcissement
 * préventif (1 attribut single-quoted existe déjà dans page-project.js,
 * et tout futur `style='${...}'` créerait un trou).
 *
 * Renvoie une chaîne vide pour null/undefined.
 *
 * Signature `unknown` et non `string | number | …` : un helper d'échappement
 * doit accepter TOUT ce qu'un template literal peut interpoler, sinon les
 * appelants contournent le typage plutôt que d'échapper. Le corps fait déjà
 * `String(s)`. Élargie le 2026-09-10 en branchant core.ts sur ce module.
 *
 * Convention non négociable du projet (cf. CLAUDE.md "Patterns dangereux"
 * et la règle ESLint `no-restricted-syntax` qui bloque
 * `.innerHTML = <variable>`) : toujours passer par `esc()` ou
 * `textContent` avant d'injecter dans le DOM.
 */
export function esc(s: unknown): string {
  if (s == null) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
